import { useCallback } from 'react';
import { highlightRing } from '../styles/colors';

export {};

interface ScrollAndHighlightOptions {
  highlightDuration?: number;
  scrollBehavior?: ScrollBehavior;
  scrollBlock?: ScrollLogicalPosition;
}

export const useScrollAndHighlight = (options: ScrollAndHighlightOptions = {}) => {
  const {
    highlightDuration = 1500,
    scrollBehavior = 'smooth',
    scrollBlock = 'center'
  } = options;

  const scrollAndHighlight = useCallback((
    element: Element | null,
    highlightClasses: readonly string[] = highlightRing.classes
  ) => {
    if (!element) return;

    // Scroll to element
    element.scrollIntoView({ 
      behavior: scrollBehavior, 
      block: scrollBlock 
    });

    // Add highlight classes
    element.classList.add(...highlightClasses);

    // Remove highlight classes after duration
    setTimeout(() => {
      element.classList.remove(...highlightClasses);
    }, highlightDuration);
  }, [highlightDuration, scrollBehavior, scrollBlock]);

  const scrollToElement = useCallback((
    selector: string,
    highlightClasses?: readonly string[]
  ) => {
    const element = document.querySelector(selector);
    scrollAndHighlight(element, highlightClasses);
  }, [scrollAndHighlight]);

  const scrollToElementById = useCallback((
    id: string,
    highlightClasses?: readonly string[]
  ) => {
    const element = document.getElementById(id);
    scrollAndHighlight(element, highlightClasses);
  }, [scrollAndHighlight]);

  return {
    scrollAndHighlight,
    scrollToElement,
    scrollToElementById
  };
};
